export { default } from './PrivacyPolicy';



// WEBPACK FOOTER //
// ./src/components/Help/PrivacyPolicy/index.ts